module.exports = __webpack_public_path__ + "img/momo_tu.b0a1b9ad.png";